import type { ApiError } from '@pbt/pbt-ui-components'

import { getErrorMessage } from './errors'

export const isPayPreferencesBraintreeMaidDuplicateError = (
  error: ApiError | string | undefined | null,
): boolean => {
  const text =
    typeof error === 'string'
      ? error
      : `${getErrorMessage(error)} ${JSON.stringify(error ?? '')}`
  return (
    /DuplicateKeyException/i.test(text) &&
    /business_braintree_settings/i.test(text) &&
    /merchant_account_id/i.test(text)
  )
}
